import { useEffect, useState, useCallback } from "react";
import { KEYS, load, save } from "@/lib/storage";

const DEFAULTS = {
  sound: true,
  music: false,
  haptics: true,
  animationSpeed: 1.0, // 0.5 (slow) – 2 (fast)
  reducedMotion: false,
  confirmMove: false,
  hints: true,
  moveExplanations: true,
  boardTheme: "earth",      // earth | carved | parchment
  counterStyle: "seed",     // seed | stone | bead
  highContrast: false,
  textSize: "normal",       // small | normal | large
  coordLabels: false,
  passDeviceScreen: false,
  language: "en",
};

export function getSettings() {
  return { ...DEFAULTS, ...(load(KEYS.settings) || {}) };
}

export function useSettings() {
  const [settings, setSettings] = useState(() => getSettings());

  const update = useCallback((patch) => {
    setSettings((prev) => {
      const next = { ...prev, ...patch };
      save(KEYS.settings, next);
      return next;
    });
  }, []);

  const reset = useCallback(() => {
    save(KEYS.settings, DEFAULTS);
    setSettings(DEFAULTS);
  }, []);

  useEffect(() => {
    // Apply text-size root class
    const root = document.documentElement;
    root.classList.remove("text-base", "text-sm", "text-lg");
    if (settings.textSize === "small") root.classList.add("text-sm");
    else if (settings.textSize === "large") root.classList.add("text-lg");
    // High contrast root class
    root.classList.toggle("high-contrast", !!settings.highContrast);
  }, [settings.textSize, settings.highContrast]);

  return { settings, update, reset };
}
